import React from 'react';
import * as Styles from 'pages/member/wh/WH.style';
import { useTranslation } from 'react-i18next';
import Checkbox from 'components/common/radio-button';
import { Grid } from '@mui/material';
import { getAppImage } from 'constants/wh';
import { get } from 'lodash';
import FormikErrorMessage from 'components/formik-error-message';
import { H6, P } from 'components/reusable-css';
import { NewStepDescription } from 'assets/css/common-styles';
import Heading from 'components/Heading/Heading';

const WHStep3 = ({ whAppData, formikProp }) => {
  const { t } = useTranslation();
  const { setFieldValue, values } = formikProp;

  return (
    <Styles.WHStep3SC id="ST3">
      <Heading name={'wh/create.step3_string1'}>
        <NewStepDescription />
        <Styles.Margin>
          <P>{t('wh/create.step3_string2')}</P>
          <Grid container spacing={0} style={{ paddingTop: '1em' }}>
            <Grid item xs={12} sm={4} md={3} lg={4} xl={2}>
              <Styles.FlexContainerWidth onClick={() => setFieldValue('app', 'no_app')}>
                <Checkbox
                  checkbox={values.app}
                  setCheckedValue={() => setFieldValue('app', 'no_app')}
                  data={{
                    id: 'no_app',
                    title_en: 'no_app',
                  }}
                />
                <H6 className="flexData">{t('wh/create.step3_string3')}</H6>
              </Styles.FlexContainerWidth>
            </Grid>
            {get(whAppData, 'data', [])
              .filter((val) => val.active && val.deployable)
              .map((val) => (
                <Grid item key={val?.id} xs={12} sm={4} md={3} lg={4} xl={2}>
                  <Styles.FlexContainerWidth key={val?.id} onClick={() => setFieldValue('app', val.id)}>
                    <Checkbox checkbox={values.app} setCheckedValue={() => setFieldValue('app', val.id)} data={val} />
                    <div>
                      <img src={getAppImage(val?.id)} width={25} height={25} alt="OS Image" />
                    </div>
                    <H6 className="flexData">{t(`wh/create.${val?.i18n_key}`)}</H6>
                  </Styles.FlexContainerWidth>
                </Grid>
              ))}
          </Grid>
        </Styles.Margin>
        <FormikErrorMessage formikProp={formikProp} value="app" />
      </Heading>
    </Styles.WHStep3SC>
  );
};
export default WHStep3;
